import { Component, Input } from "@angular/core";
import { Product } from "src/app/meta/Product.interface";

@Component({
    selector: "ow-order-summary-product",
    templateUrl: "./order-summary-product.component.html"
})
export class OrderSummaryProductComponent {

    @Input() baseProduct!: Product
    @Input() demandAggregation!: boolean

}
